module.exports = __webpack_public_path__ + "static/media/bafta.64e502a1.svg";